/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, useState} from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import "../../CSS/DataModal.css";
import "react-datepicker/dist/react-datepicker.css";
import CommonModal from "../CommonModal/CommonModal";
import Provisioning from "../Provisioning/Provisioning";
import PropTypes from "prop-types";

const animatedComponents = makeAnimated();

const otherOption = {id: -1, action: "Other"};
const YES_OPTION = "Yes";
const NO_OPTION = "No";

function ResolvedByModal({show, onClick, suggestedAction, typeActions, onYes, alert}) {
    //const { show, onClick, suggestedAction, typeActions, onYes, alert } = props;
    const [selectedRadio, setSelectedRadio] = useState(YES_OPTION);
    const [selectedOption, setSelectedOption] = useState(null);
    const [inputAction, setInputAction] = useState("");
    const [actionList, setActionList] = useState([]);
    
    function getActionList() {
        let list = typeActions !== null && typeActions?.length ? typeActions : [];
        list = list.concat(otherOption);
        setActionList(list);
        return list;
    }
    
    const changeRadio = (e) => {
        setSelectedRadio(e.target.value);
    }
    
    const onChangeAction = (option) => {
        setSelectedOption(option);
    }
    
    const onChangeInput = (e) => {
        setInputAction(e.target.value);
    }
    
    const getOptionLabel = (option) => {
        return (option.action)
    }
    
    const getOptionValue = (option) => {
        return (option.id)
    }
    
    const onContinue = () => {
        let resolvedAlert = {
            alertId: alert.alertId,
            alertTypeId: alert.alertTypeId,
            resolvedBySuggested: true,
            resolveActionId: null
        };
        if (selectedRadio === NO_OPTION) {
            resolvedAlert.resolvedBySuggested = false;
            if (selectedOption === otherOption) {
                resolvedAlert.resolveAction = inputAction;
            }
            else {
                resolvedAlert.resolveActionId = selectedOption.id;
            }
        }
        onYes(resolvedAlert);

        setSelectedRadio(YES_OPTION);
        setSelectedOption(null);
        setInputAction("");
    }
    
    let options = typeActions !== undefined ? typeActions.concat(otherOption) : [].concat(otherOption);
    
    let otherInput = selectedOption === otherOption ?
        <input
            type="text"
            className="form-control"
            id="action"
            name="action"
            value={inputAction}
            onChange={onChangeInput}
            placeholder="Enter action taken to resolve the alert"
        />
        : null;
    
    let noContent = selectedRadio === NO_OPTION ?
        <div>
            <label htmlFor="description" ><b>Resolved By:</b> </label>
            <Select
                closeMenuOnSelect={true}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999999999 }) }}
                menuPortalTarget={document.body}
                components={animatedComponents}
                options={options}
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
                value={selectedOption}
                onChange={onChangeAction}
                placeholder="--Select Action--"
            />
            <br/>
            {otherInput}
        </div>
        : null;
    
    let modalContent = <div>
        <label htmlFor="description" ><b>Suggested Action:</b> </label><br/>
        <a>{suggestedAction}</a>
        
        <br/>
        <label htmlFor="description" ><b>Did this action resolve the alert?</b> </label>
        <div onChange={e => changeRadio(e)} className={"pad-left-40 margin-5"}>
            <div>
                <input type="radio" value="Yes" defaultChecked name="suggestedResolved" />
                &nbsp; Yes &nbsp;&nbsp;
                <input type="radio" value="No" name="suggestedResolved" />
                &nbsp; No &nbsp;&nbsp;
            </div>
        </div>
        <br/>


        {noContent}
    </div>
    
    if (show) {
        return (
            <div>
                <CommonModal show={show} onYes={onContinue} onClick={onClick} content={modalContent} title={'Alert Resolved By Form'} />
            </div>
        )
    }
    else {
        return null;
    }
}

ResolvedByModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    suggestedAction: PropTypes.string.isRequired,
    typeActions: PropTypes.array,
    onYes: PropTypes.func.isRequired,
    alert: PropTypes.object
};

export default ResolvedByModal;